import http from '@/services/http'
import { delayed } from '@/utils'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    applications: [],
  },
  mutations: {
    CLEAN(state) {
      state.fetchInProgress = false
      state.applications = []
    },
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    SET_APPLICATIONS(state, applications) {
      state.applications = applications
    },
  },
  getters: {
    totalCount: (state) => state.applications.length,
    answered: (state) =>
      state.applications.filter((a) => a.state === 'submitted'),
    answeredCount: (state) =>
      state.applications.filter((a) => a.state === 'submitted').length,
    drafts: (state) => state.applications.filter((a) => a.state === 'draft'),
    draftsCount: (state) =>
      state.applications.filter((a) => a.state === 'draft').length,
  },
  actions: {
    fetch,
    silentFetch,
  },
}

async function fetch(
  { commit, state },
  { organizationId, programId, delay = 250 },
) {
  commit('START_FETCH')
  await silentFetch({ commit, state }, { organizationId, programId, delay })
  commit('STOP_FETCH')
}

async function silentFetch(
  { commit, state },
  { organizationId, programId, delay = 250 },
) {
  const url = `/organizations/${organizationId}/applications`
  const params = { program_id: programId }
  const request = delayed(http.getAuthed(url, params), delay)
  const response = await request
  commit('SET_APPLICATIONS', response.data)
  return response
}
